// client/src/components/HOME/HomeFooter.js

import React from "react";
import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  { to: "/legal/mentions-legales", label: "Mentions légales" },
  { to: "/legal/cgu", label: "CGU" },
  { to: "/legal/cgv", label: "CGV" },
  { to: "/legal/conditions-affilies", label: "Conditions affiliés" },
  { to: "/legal/politique-confidentialite", label: "Confidentialité" },
  { to: "/legal/politique-cookies", label: "Cookies" },
];

const FOOTER_CSS = `
.lp-footer { margin-top: auto; background: var(--eb-brand-900); color: rgba(255, 255, 255, 0.72); }
.lp-footer__inner {
  max-width: 1180px; margin: 0 auto; padding: 28px clamp(16px, 5vw, 32px);
  display: flex; align-items: center; justify-content: space-between; gap: 16px 32px; flex-wrap: wrap;
}
.lp-footer__links { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 20px; }
.lp-footer__link { color: rgba(255, 255, 255, 0.68); text-decoration: none; font-size: 13.5px; white-space: nowrap; transition: color 0.15s ease; }
.lp-footer__link:hover { color: #fff; text-decoration: underline; }
.lp-footer__link--strong { color: #fff; font-weight: 600; }
.lp-footer__sep { width: 1px; height: 14px; background: rgba(255, 255, 255, 0.2); }
.lp-footer__copy { font-size: 13px; color: rgba(255, 255, 255, 0.5); }
@media (max-width: 899px) {
  .lp-footer__inner { flex-direction: column; text-align: center; padding: 24px 20px 28px; }
  .lp-footer__links { justify-content: center; gap: 4px 16px; }
  .lp-footer__link { display: inline-flex; align-items: center; min-height: 32px; }
  .lp-footer__sep { display: none; }
  .lp-footer__links .lp-footer__link--strong { flex-basis: 100%; justify-content: center; }
}
`;

export default function HomeFooter() {
  return (
    <footer className="lp-footer">
      <style>{FOOTER_CSS}</style>
      <div className="lp-footer__inner">
        <nav className="lp-footer__links" aria-label="Liens légaux">
          <Link to="/affiliatessignup" className="lp-footer__link lp-footer__link--strong">
            Ecobill Affiliates
          </Link>

          <span className="lp-footer__sep" aria-hidden="true" />

          {LEGAL_LINKS.map(({ to, label }) => (
            <Link key={to} to={to} className="lp-footer__link">
              {label}
            </Link>
          ))}
        </nav>

        <div className="lp-footer__copy">
          © {new Date().getFullYear()} Ecobill — ECOBILL SAS &amp; Solution Ecobil Canada Inc. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}
